import { SBModelComponent } from '@supplement-bacon/react-toolkit/models'
import { FC } from 'react'
import { Menu as MenuModel } from '../../models/Menu'
import { useAppSelector } from '../../store/hooks'
import { selectMenuById } from '../../store/MenuReducer'

type Props = SBModelComponent<MenuModel> & {}

const MenuOption: FC<Props> = ({ id, model }) => {
  const item = model ? model : useAppSelector(selectMenuById(id!))

  if (!item) {
    return <></>
  }

  return item.en.label
}

type MenuOptionType = { Option: typeof MenuOption }

export { MenuOption, type MenuOptionType }
